import React, { Component } from "react";
import { convertStringToElements } from "@vds/html-parsers";
import styled from "styled-components";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import { setA11yContent } from "../../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { checkAMLob } from "utils/checkAMLob";
import { TitleLockup } from "@vds/type-lockups";

import Header from "common-components/Header";
import Container from "common-components/Container";
import Button from "common-components/Buttons";

class ActionNeeded extends Component {
  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
      this.props.setA11yContent("Action needed", this.props.pageContent.sc_pagetitle);
    }
  }

  renderContent = pageContent => {
    if (checkAMLob() === "vzw") {
      if (window.reactGlobals.amRole === "prepay" && pageContent.section_prepayDescription) {
        return pageContent.section_prepayDescription;
      } else if (pageContent.section_postpayDescription) {
        return pageContent.section_postpayDescription;
      }
    }
    return pageContent.section_description;
  };

  render() {
    const { pageContent } = this.props;

    if (!pageContent) {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    return (
      <Container>
        <div style={{ maxWidth: "422px" }}>
        <TitleLockup 
            surface='light'
            textAlignment='left'
            data={{
              title:{
                size: 'titleXLarge',
                bold: false,
                children: convertStringToElements(pageContent.section_title)
              },
              subtitle:{
                size: 'bodyLarge',
                children: <Div>{convertStringToElements(this.renderContent(pageContent))}</Div>
              }
          }}  
        />
        </div>
        <Button background={pageContent.buttons[0].type} onClick={() => this.props.history.push("your-data")}>
          {pageContent.buttons[0].text}
        </Button>
      </Container>
    );
  }
}

const mapStateToProps = ({ pageContent: { email_message_verification_update: pageContent } }) => ({
  pageContent
});

ActionNeeded.propTypes = {
  pageContent: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  { setA11yContent }
)(ActionNeeded);

const Div = styled.div`
  margin-bottom: 36px;

  ul {
    list-style: disc inside;
  }
  p,
  li {
    padding: 10px 0;
    font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif

  }
`;
